<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedMonth"
                label="Select Month"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedMonth"
              type="month"
              @change="updateTableData"
              no-title
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-data-table
        hide-default-footer
        :headers="headers"
        :items="tableData"
        class="elevation-1"
      ></v-data-table>
      <br>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="inputNumber"
            label="Enter Budget Amount"
            type="number"
            outlined
          ></v-text-field>
          <v-btn @click="calculateRevenueRatio">Calculate Revenue Ratio</v-btn>
          <div v-if="revenueRatio !== null">
            <h3>Revenue Ratio: {{ revenueRatio }}%</h3>
          </div>
        </v-col>
        <v-col cols="12">
          <h3>Appointments to Presentations Ratio: {{ appointmentsToPresentationsRatio }}%</h3>
        </v-col>
        <v-col cols="12">
          <h3>Presentations to Sales Ratio: {{ presentationsToSalesRatio }}%</h3>
        </v-col>
        <v-col cols="12">
          <h3>Calls to Appointments Ratio: {{ callsToAppointmentsRatio }}%</h3>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { axios } from '../../../utils';

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      menu: false,
      selectedMonth: new Date().toISOString().substr(0, 7), // YYYY-MM
      inputNumber: 40000,
      revenueRatio: null,
      appointmentsToPresentationsRatio: null,
      presentationsToSalesRatio: null,
      callsToAppointmentsRatio: null,
      headers: [
        { text: 'Calls', value: 'calls' },
        { text: 'Appointments', value: 'appointments' },
        { text: 'Presentations', value: 'presentations' },
        { text: 'Sales', value: 'sales' },
        { text: 'Revenue', value: 'revenue' },
      ],
      tableData: [],
    };
  },
  methods: {
    getStartDate(year, month) {
      const firstDay = new Date(year, month, 1);
      const dayOfWeek = firstDay.getDay();
      const firstMonday = new Date(firstDay);

      // Calculate the offset to the first Monday
      const offset = (dayOfWeek === 0) ? 1 : (9 - dayOfWeek) % 7;
      firstMonday.setDate(firstDay.getDate() + offset);

      return firstMonday;
    },
    getEndDate(startOfMonth) {
      const year = startOfMonth.getFullYear();
      const month = startOfMonth.getMonth();
      const endOfMonth = new Date(year, month + 1, 0); // last day of the current month

      // Calculate the number of days to add to reach the next Sunday
      const daysUntilSunday = (7 - endOfMonth.getDay()) % 7;
      const lastDayOfWeek = new Date(endOfMonth);
      lastDayOfWeek.setDate(endOfMonth.getDate() + daysUntilSunday);

      return lastDayOfWeek;
    },
    async getEmployeeWeeklyTotals(start, end) {
      try {
        const response = await axios.get('api/admin/phone-calls/employee-weekly-totals', {
          params: { start_date: start, end_date: end, employee_id: this.id },
        });

        const totalCalls = response.data.total_calls;
        const totalAppointments = response.data.total_appointments;
        const totalPresentations = response.data.total_presentations;
        const totalSales = response.data.total_sales;
        const totalRevenue = response.data.revenue;

        this.tableData = [{
          calls: totalCalls,
          appointments: totalAppointments,
          presentations: totalPresentations,
          sales: totalSales,
          revenue: totalRevenue,
        }];
        this.calculateAppointmentsToPresentationsRatio();
        this.calculateCallsToAppointmentsRatio();
        this.calculatePresentationsToSalesRatio();
      } catch (error) {
        console.log(error);
      }
    },
    updateTableData() {
      const [year, month] = this.selectedMonth.split('-').map(Number);
      const startDate = this.getStartDate(year, month - 1);
      const endDate = this.getEndDate(startDate);
         const startMs = new Date(startDate).getTime();
      const endMs = new Date(endDate).getTime();

      // Calculate the difference in milliseconds
      const diffMs = endMs - startMs;

      // Convert the difference to weeks (approximated)
      const weeks = Math.round(diffMs / (1000 * 60 * 60 * 24 * 7));
      this.inputNumber = weeks * 10000;
      this.getEmployeeWeeklyTotals(startDate, endDate);
    },
    calculateRevenueRatio() {
      if (this.tableData.length > 0 && this.tableData[0].revenue) {
        this.revenueRatio = (this.tableData[0].revenue / this.inputNumber) * 100;
      } else {
        this.revenueRatio = null;
      }
    },
    calculateAppointmentsToPresentationsRatio() {
      if (this.tableData.length > 0 && this.tableData[0].appointments && this.tableData[0].presentations) {
        this.appointmentsToPresentationsRatio = (this.tableData[0].presentations /this.tableData[0].appointments) * 100;
      } else {
        this.appointmentsToPresentationsRatio = null;
      }
    },
    calculatePresentationsToSalesRatio() {
      if (this.tableData.length > 0 && this.tableData[0].presentations && this.tableData[0].sales) {
        this.presentationsToSalesRatio = (this.tableData[0].sales/ this.tableData[0].presentations) * 100;
      } else {
        this.presentationsToSalesRatio = null;
      }
    },
    calculateCallsToAppointmentsRatio() {
      if (this.tableData.length > 0 && this.tableData[0].calls && this.tableData[0].appointments) {
        this.callsToAppointmentsRatio = (this.tableData[0].appointments /this.tableData[0].calls) * 100;
      } else {
        this.callsToAppointmentsRatio = null;
      }
    },
  },
  mounted() {
    this.updateTableData();
  },
};
</script>
